import { css } from '@emotion/react';

export const root = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: var(--zindex-modal);
`;

export const overlay = css`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: rgba(48, 48, 51, 0.7);
`;

export const content = (width = '44.8rem') => css`
  width: ${width};
  border-radius: 0.6rem;
  background: var(--color-white);
`;

export const header = css`
  display: flex;
  align-items: center;
  padding: 1.6rem;
  line-height: 1.23;
`;

export const title = css`
  flex: 1;
  font-size: 2.1rem;
  font-weight: 700;
`;

export const body = css`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 1.6rem;
`;

export const text = css`
  font-size: 1.4rem;
`;

export const footer = css`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;
  padding: 1.6rem 2.4rem;
`;
